import { AccountConfigOptions } from "./AccountConfigOptions";

export function getDefaultAccountConfigOptions(): AccountConfigOptions {
    return {
        query: {
            UiVersion: undefined
        }
    };
}
